import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Backoffice from './backend';
import brain from './brain';
import RXC_CRASH_POPUP from './components/backoffice/RXC_CRASH_POPUP/RXC_CRASH_POPUP';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import './index.scss';
// import(`./_vendors.css`);
// import(`./sgh-reset.css`);
import { store } from './redux/store';

async function loadScssFile(brand: string) {
  try {
    // if (brand === 'sgh') {
    //   await import(`./reset.css`);
    // }
    // await import(`./index.scss`);
    import(`./skins/${brand}.scss`);
  } catch (err) {
    console.error('Error loading the skin', err);
  }
}
declare global {
  interface Window {
    rxcBrain: any;
    RXC: any;
    RXC_LOADED?: boolean;
  }
}

// const RemoteComponent = lazy(() =>
//   import("remote/nextjs-remote-page").catch(() => {
//     return { default: () => <>NextJs remote unavailable!</> };
//   })
// );

// const App = ({ config = null }: any) => {
//   return (
//     <Suspense fallback={null}>
//       <RemoteComponent config={config} />
//     </Suspense>
//   );
// };
const queryClient = new QueryClient();
export default function App({ config = null }) {
  // load the correct css file based on brand/channel
  useLayoutEffect(() => {
    loadScssFile(config?.brand);
  }, []);

  useEffect(() => {
    return () => {
      window.RXC_LOADED = false;
    };
  }, []);

  useLayoutEffect(() => {
    // hide scrollbar on ecommerce website html tag
    document.documentElement.style.overflow = 'hidden';

    return () => {
      // remove during unmount
      document.documentElement.style.overflow = '';
    };
  }, []);

  if (!window?.rxcBrain) return <></>;
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary fallback={<RXC_CRASH_POPUP />}>
        <Provider store={store}>
          <Backoffice config={config} />
        </Provider>
      </ErrorBoundary>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

const rxcWidget: any = {
  roots: {}, // Store roots here, keyed by selector
  new: (config: any) => {
    rxcWidget['selector'] = config?.selector || '';
    brain.init(config);

    // make brain global
    window.rxcBrain = brain;

    const preconnectLink = document.createElement('link');
    preconnectLink.rel = 'preconnect';
    preconnectLink.href = 'https://vmmv.luxottica.com';

    document.head.appendChild(preconnectLink);

    return {
      render: () => {
        if (config?.showUI === false) return null;
        const element = document.querySelector(config.selector);
        element.classList.add('rxcApp');
        element.setAttribute('role', 'dialog');
        element.setAttribute('aria-modal', 'true');
        const selector =
          config.selector ||
          rxcWidget.selector ||
          window.rxcBrain.config.selector;
        const oldRoot = rxcWidget.roots[selector];

        if (!oldRoot && element) {
          const root = createRoot(element);
          rxcWidget.roots[config.selector] = root; // Store the root reference
          // render application
          root.render(<App config={config} />);
        }
      },
    };
  },
  close: (selector?: string) => {
    selector =
      selector || rxcWidget.selector || window.rxcBrain.config.selector;
    const root = rxcWidget.roots[selector];

    if (root) {
      root.unmount();
      delete rxcWidget.roots[selector]; // Remove the stored root reference
    } else {
      console.error(
        'Error during widget unmount: No mounted widget found for the selector: ' +
          selector
      );
    }

    let eventListenerList = (window as any).RXC.rxcWidget.listeners;
    if (eventListenerList) {
      Object.keys(eventListenerList).forEach((key: string) => {
        window.removeEventListener(key, eventListenerList[key]);
      });
      delete rxcWidget['listeners'];
    }
  },
};

window.RXC = { rxcWidget };

// Function to be called when all chunks are loaded
function allChunksLoaded() {
  // Dispatch a custom event to signal that all chunks are loaded
  if (window?.RXC_LOADED) return;
  const event = new Event('RXC_LOADED');
  window.RXC_LOADED = true;
  window.dispatchEvent(event);
}

// Ensure this is called when all chunks are done loading
allChunksLoaded();
